"use client";
import { useNavigate } from "react-router-dom";

const MsFeeStructurePage = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="container mx-auto px-4 py-6 md:py-4">
      <button
        onClick={goBack}
        className="mb-4 flex items-center gap-3 text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg py-3 px-6 shadow-md hover:shadow-lg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6"
        >
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
        <span className="font-medium text-lg">Go Back</span>
      </button>

      <div className="border-0 shadow-lg overflow-hidden rounded-lg">
        {/* Header Section */}
        <div className="bg-[#1e3a8a] text-white p-4 md:p-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center md:space-x-4 text-center md:text-left">
              <img
                src="/logo.png"
                alt="NASTP Logo"
                width={80}
                height={80}
                className="rounded-full mb-2 md:mb-0"
              />
              <div>
                <h1 className="text-xl md:text-2xl lg:text-3xl font-bold tracking-tight">
                  NASTP INSTITUTE OF INFORMATION
                </h1>
                <h2 className="text-lg md:text-xl lg:text-2xl font-bold tracking-tight">
                  TECHNOLOGY (NIIT), LAHORE
                </h2>
              </div>
            </div>
            <img
              src="/air-logo-transpatrent.png"
              alt="Air University Logo"
              width={100}
              height={100}
              className="mt-2 md:mt-0"
            />
          </div>
        </div>

        {/* Main Content */}
        <div className="p-0">
          <div className="bg-gray-100 py-6 px-4 md:py-8 md:px-6">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-gray-800">
              MS Programs Fee Structure
            </h2>
          </div>

          <div className="p-4 md:p-6">
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                Available Programs
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-blue-50 rounded-lg p-4 shadow-md">
                  <h4 className="text-lg font-semibold text-blue-800 mb-2">
                    MS Computer Science
                  </h4>
                  <p className="text-gray-700">(Evening / Weekend Program)</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 shadow-md">
                  <h4 className="text-lg font-semibold text-blue-800 mb-2">
                    MS Artificial Intelligence
                  </h4>
                  <p className="text-gray-700">(Evening / Weekend Program)</p>
                </div>
              </div>
            </div>

            <div className="overflow-x-auto">
              {/* Fee Structure Table */}
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <th className="border-b-2 border-gray-300 py-3 md:py-4 px-3 md:px-6 text-left text-base md:text-xl font-semibold text-gray-800">
                      Fee Component
                    </th>
                    <th className="border-b-2 border-gray-300 py-3 md:py-4 px-3 md:px-6 text-left text-base md:text-xl font-semibold text-gray-800">
                      Amount (PKR)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Admission Fee
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      20,000 (one time)
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Security Deposit
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      20,000 (refundable)
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Semester 1
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      162,000
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Semester 2
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      162,000
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Semester 3
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      108,000
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-medium">
                      Semester 4
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg">
                      108,000
                    </td>
                  </tr>
                  <tr className="bg-blue-50">
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-bold">
                      Total Cost of MS Program (2 Years)
                    </td>
                    <td className="border-b border-gray-200 py-3 md:py-4 px-3 md:px-6 text-sm md:text-lg font-bold">
                      560,000
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-6 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <p className="text-gray-800">
                <span className="font-semibold">Note:</span> Upto 100%
                scholarships available. Amount of scholarship will be decided by
                admission committee based on academic record and research
                potential.
              </p>
            </div>

            {/* Contact Information */}
            <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-gray-700">
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-base md:text-lg">
                  69-Abid Majeed Road, Lahore Cantt
                </span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <span className="text-base md:text-lg">0320-9420163</span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <span className="text-base md:text-lg">042-36666033</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MsFeeStructurePage;
